import React from 'react'
import { Navbar } from '../component/Navbar/Navbar'
import { Footer } from '../component/Footer/Footer'
import { Order } from '../component/Order/Order'

export const Com_order = () => {
    return (
        <div>
            <Navbar/>
            <Order/>
            <Footer/>
            
        </div>
    )
}
